/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Email } from '../models/Email';
import type { PaginatedProviderSurveyResponseList } from '../models/PaginatedProviderSurveyResponseList';
import type { PatchedProviderSurveyResponse } from '../models/PatchedProviderSurveyResponse';
import type { ProviderSurveyResponse } from '../models/ProviderSurveyResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ProviderSurveyResponseService {

    /**
     * @returns ProviderSurveyResponse
     * @throws ApiError
     */
    public static providerSurveyResponseRetrieve({
        id,
    }: {
        /**
         * A UUID string identifying this provider survey response.
         */
        id: string,
    }): CancelablePromise<ProviderSurveyResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/provider-survey-response/{id}/',
            path: {
                'id': id,
            },
        });
    }

    /**
     * @returns ProviderSurveyResponse
     * @throws ApiError
     */
    public static providerSurveyResponseUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this provider survey response.
         */
        id: string,
        requestBody?: ProviderSurveyResponse,
    }): CancelablePromise<ProviderSurveyResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/provider-survey-response/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns ProviderSurveyResponse
     * @throws ApiError
     */
    public static providerSurveyResponsePartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A UUID string identifying this provider survey response.
         */
        id: string,
        requestBody?: PatchedProviderSurveyResponse,
    }): CancelablePromise<ProviderSurveyResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/provider-survey-response/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * Outstanding Provider References Lookup
     * Fetch any outstanding endorsements for provider references sent to given email address
     * @returns PaginatedProviderSurveyResponseList
     * @throws ApiError
     */
    public static providerSurveyResponsesOutstanding({
        requestBody,
        limit,
        offset,
    }: {
        requestBody: Email,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
    }): CancelablePromise<PaginatedProviderSurveyResponseList> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/provider-survey-response/outstanding/',
            query: {
                'limit': limit,
                'offset': offset,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
